import React, { useEffect } from 'react'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { Controller, useForm } from 'react-hook-form'
import SwalCustom from '../../alert/swal-custom'
import { postContractSettingAPI } from '../../services/setting-contracts'
import Swal from 'sweetalert2'
import Error_false from '../error/error-false'
import ModalCustom from '../modal-custom'
import { Button, Col, Form } from 'react-bootstrap'
import LabelCustom from '../label-custom'
import { TXTSUCCESS } from '../../Constants'
import InputIDCardNumber from '../input-idcard-num'

const schema = yup
  .object({
    idCard: yup.string().required('Please, Input ID Card')
  })
  .required()
export default function AddContracts({
  setIsSave,
  showCreate,
  isSave,
  setIsRefresh,
  fnGetData,
  setShowCreate,
  orgId,
  handleKeyDownNum
}) {
  const {
    control,
    setError,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })

  useEffect(() => {
    fnGetData()
  }, [isSave])

  const onSubmit = (d) => {
    const body = {
      idCard: d.idCard.replace(/\s/g, '') ?? '',
      orgId: orgId
    }
    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to create new?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: 'var(--comp-badge-color-background-primary)',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSave(true)
        createContracts(body)
      }
    })
  }

  const createContracts = async (body) => {
    const results = await postContractSettingAPI(body)
    if (!results) {
      setIsSave(false)
      return
    }
    if (results.status) {
      SwalCustom({
        title: `Success!`,
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        fnGetData()
        setIsRefresh(true)
        Swal.close()
      })
    } else {
      Error_false(results)
    }
    setIsSave(false)
    fnReset()
    handleClose()
  }

  const fnReset = () => {
    setError('type', false)
    setError('date', false)
    setError('detail', false)
  }

  const handleClose = () => {
    setShowCreate(false)
    fnReset()
  }

  return (
    <ModalCustom width={500} open={showCreate} onCancel={handleClose}>
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="mt-3 row"
        style={{ rowGap: '13px' }}
      >
        <label>Add Contract</label>

        <Col md={12}>
          <LabelCustom text={'ID Card'} />
          <Controller
            name={'idCard'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <InputIDCardNumber value={value} onChange={onChange} />

              // <Form.Control
              //     maxLength={13}
              //     value={value}
              //     onChange={onChange}
              //     onKeyDown={handleKeyDownNum}
              //   />
            )}
          />
          {errors.idCard?.message && (
            <label className="small text-danger">{errors.idCard.message}</label>
          )}
        </Col>

        <Col xl={12} className="text-center mt-4">
          <Button
            className="px-4 me-2 bg-secondary text-white"
            variant="light"
            type="button"
            // disabled={isSave}
            onClick={handleClose}
          >
            Close
          </Button>
          <Button type="submit" className="px-4" disabled={isSave}>
            {isSave ? 'Saving...' : 'Save'}
          </Button>
        </Col>
      </Form>
    </ModalCustom>
  )
}
